import { render, staticRenderFns } from "./LeafNode.vue?vue&type=template&id=244fc5e8"
import script from "./LeafNode.vue?vue&type=script&lang=js"
export * from "./LeafNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports